import React from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Copy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      vestigingen: [],
      selectedVestiging: "",
      menukaarten: [],
      selectedMenukaart: "",
    };
  }

  componentDidMount() {
    if (this.props.open && this.state.vestigingen.length === 0) {
      this.loadVestigingen();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && this.state.vestigingen.length === 0) {
      this.loadVestigingen();
    }

    if (this.state.selectedVestiging !== "" && this.state.selectedVestiging !== prevState.selectedVestiging) {
      this.loadMenukaarten();
    }
  }

  loadVestigingen = () => {
    axios
      .get("core/vestigingen?per_page=5000&fields=id,systeemNaam as naam&sort_field=systeemNaam&sort_dir=asc")
      .then((response) => {
        let vestigingen = response.data.data.data;
        this.setState({ vestigingen: vestigingen });
      });
  };

  loadMenukaarten = () => {
    axios
      .get(
        "core/kaarten?per_page=1000&fields=id,naam&sort_field=naam&sort_dir=asc&vestiging_id=" +
          this.state.selectedVestiging
      )
      .then((response) => {
        let menukaarten = response.data.data.data;
        this.setState({ menukaarten: menukaarten });
      });
  };

  showMenukaarten = () => {
    return this.state.menukaarten.length > 0 && this.state.selectedVestiging !== "";
  };

  handleType = (name) => (event) => {
    let newState = { ...this.state };
    newState[name] = event.target.value;
    this.setState(newState);
  };

  save = () => {
    this.setState({ saving: true });

    let data = {
      product_ids: this.props.productIds,
      vestiging_id: this.state.selectedVestiging,
      menukaart_id: this.state.selectedMenukaart,
    };

    axios.post("core/producten/dupliceren", data).then((response) => {
      this.setState({ saving: false });
      this.props.refreshTable();
      this.props.toggle();
    });
  };

  disableSave = () => {
    return this.state.selectedMenukaart === "";
  };

  render() {
    const { classes } = this.props;

    let vestigingenItems = this.state.vestigingen.map((prop, key) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={key}
          value={prop.id}
        >
          {prop.naam}
        </MenuItem>
      );
    });

    let menukaartenItems = this.state.menukaarten.map((prop, key) => {
      return (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={key}
          value={prop.id}
        >
          {prop.naam}
        </MenuItem>
      );
    });

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        fullWidth
        keepMounted
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Kopieer een product"} tKey={"producten.modal.copy.titel"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"Vestiging"} tKey={"producten.modal.copy.form.selectedVestiging"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <FormControl className={classes.selectFormControl} fullWidth>
                <Select
                  MenuProps={{
                    className: classes.selectMenu,
                  }}
                  classes={{
                    select: classes.select,
                  }}
                  inputProps={{
                    name: "simpleSelect",
                    id: "simple-select",
                    style: { paddingTop: "32px" },
                  }}
                  onChange={this.handleType("selectedVestiging")}
                  value={this.state.selectedVestiging}
                >
                  {vestigingenItems}
                </Select>
              </FormControl>
            </GridItem>
          </GridContainer>

          {this.showMenukaarten() ? (
            <GridContainer>
              <GridItem sm={2} xs={12}>
                <FormLabel className={classes.labelHorizontal}>
                  <TranslationWrapper tDefault={"Menukaart"} tKey={"producten.modal.copy.form.selectedMenukaart"} />
                </FormLabel>
              </GridItem>
              <GridItem sm={10} xs={12}>
                <FormControl className={classes.selectFormControl} fullWidth>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    classes={{
                      select: classes.select,
                    }}
                    inputProps={{
                      name: "simpleSelect",
                      id: "simple-select",
                      style: { paddingTop: "32px" },
                    }}
                    onChange={this.handleType("selectedMenukaart")}
                    value={this.state.selectedMenukaart}
                  >
                    {menukaartenItems}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
          ) : null}
        </DialogContent>
        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={<TranslationWrapper tDefault={"Dupliceer product"} tKey={"producten.modal.copy.button.save"} />}
            disabled={this.disableSave()}
            onClick={this.save}
            saving={this.state.saving}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(Copy, notificationsStyle);
